import { render } from "./cart-cross-sell.vue?vue&type=template&id=4d234860"
import script from "./cart-cross-sell.vue?vue&type=script&lang=js"
export * from "./cart-cross-sell.vue?vue&type=script&lang=js"

import "./cart-cross-sell.vue?vue&type=style&index=0&id=4d234860&lang=scss"

import exportComponent from "/buddy/derek-lam/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__